module.exports = __webpack_public_path__ + "static/grecianIsleRules-winning-min.d1d8b90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructional/grecianIsleRules-winning-min.jpg
// module id = 149
// module chunks = 66570062548345 213534597649335